import { render, staticRenderFns } from "./AdjustmentItemDetail.vue?vue&type=template&id=2a347566"
import script from "./AdjustmentItemDetail.vue?vue&type=script&lang=js"
export * from "./AdjustmentItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports